import { useState, useEffect } from "react";
import { Provider } from "react-redux";
import { store } from "./store";
import { Toaster, ToastPosition } from "react-hot-toast";
import { ThemeProvider } from "./contexts/ThemeContext";
import ModalProvider from "./contexts/ModalProvider";
import ModalLayout from "./components/ModalLayout";

const ResponsiveToaster = () => {
  const [position, setPosition] = useState<ToastPosition>("top-right");

  useEffect(() => {
    const handleResize = () => {
      // 640px is generic mobile breakpoint, matching tailwind 'sm' usually
      // The user requested "mobile device", standard is < 768px (md) or < 640px (sm).
      // Let's use 640px to be consistent with common mobile definitions.
      if (window.innerWidth < 640) {
        setPosition("top-center");
      } else {
        setPosition("top-right");
      }
    };

    // Initial check
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return <Toaster position={position} />;
};

export const AppProviders = ({ children }: { children: React.ReactNode }) => (
  <Provider store={store}>
    <ThemeProvider>
      <ModalProvider>
        {children}
        <ModalLayout />
        <ResponsiveToaster />
      </ModalProvider>
    </ThemeProvider>
  </Provider>
);
